module.exports = __webpack_public_path__ + "static/media/jia_cheng_xu.5af842c2.jpg";